/* eslint-disable no-unused-vars */
import {
    IconChevronLeftRegular,
    NavigationBar,
    Row,
    RowList,
    Spinner,
    Text1,
    Text2,
    Text3,
    Text6,
    ThemeVariant,
    skinVars,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getBonusById } from '../../../../services/ProductService';
import './index.scss';
import { formatPrices, formatMobileNumber } from '../../../../utils/dataTransformation/unitsConversion';
import { useTranslation } from 'react-i18next';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import Stopper from '../../../../components/Stopper';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
import { getRoleLine } from '../../../../utils/dataTransformation/productConsumption';
import { useConfigureLineContext } from '../../../../utils/store/context/configure-line-context/ConfigureLineContext';

const ExtraBonusDetails: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const productId: any = searchParams.get('productId');
    const { trackingScreenView } = new TrackingEvents();
    const storage = localStorage.getItem('storage');
    const consumptions = localStorage.getItem('storages')!;
    const homeDisabled = managementEnvironment().REACT_APP_STOPPER_HOME_DISABLED;
    const { isConvergent } = useConfigureLineContext();
    let [loaded, setLoaded] = useState(false);
    const [data, setData] = useState<any>();
    let mobile;
    let phone: string;
    let cicle: any;
    let storageJson;

    if (storage) {
        storageJson = JSON.parse(storage);
        cicle = storageJson.cicle;
    }

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        getBonusById(productId)
            .then((results: any) => {
                setData(results.data);
                setLoaded(true);
            })
            .catch((err: any) => {
                console.error(err);
                setLoaded(true);
            });
    }, []);

    if (data) {
        mobile = data.mobile;
        phone = mobile.number;
    }

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <>
            {loaded ? (
                <div className='extraBonusDetails-page'>
                    <div
                        className='extraBonusDetails-page__header'
                        style={{ background: skinVars.colors.backgroundBrand }}
                    >
                        {!(isWebviewAndroid || isWebviewIOS) && (
                            <>
                                <div className='extraBonusDetails-page__header-navigationBar'>
                                    <NavigationBar
                                        isInverse={true}
                                        onBack={() => {
                                            navigate(-1);
                                        }}
                                        title={t('returnBonusExtra')}
                                    />
                                </div>
                                <div className='extraBonusDetails-page__header-return'>
                                    <div
                                        className='extraBonusDetails-page__header-return-cursor'
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                    >
                                        <div className='extraBonusDetails-page__header-return-icon'>
                                            <IconChevronLeftRegular
                                                color={skinVars.colors.appBarBackground}
                                                size={20}
                                            />
                                        </div>
                                        <Text2 medium color={skinVars.colors.appBarBackground}>
                                            {t('returnResponsive')}
                                        </Text2>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className='extraBonusDetails-page__header-breadcrumbs'>
                            <ThemeVariant isInverse>
                                <BreadCrumbsWrapper
                                    title={t('returnBonusExtra')}
                                    breadcrumbs={
                                        !isConvergent
                                            ? [{ title: t('breadcrumbsHome'), url: '/home' }]
                                            : [
                                                  { title: t('breadcrumbsHome'), url: '/home' },
                                                  {
                                                      title: getRoleLine(
                                                          JSON.parse(consumptions),
                                                          storageJson.productPsId,
                                                      ),
                                                      url: `/mobile?productPsId=${storageJson.productPsId}`,
                                                  },
                                              ]
                                    }
                                />
                            </ThemeVariant>
                        </div>
                        <div className='extraBonusDetails-page__header-title'>
                            <Text6 color={skinVars.colors.textNavigationBarPrimary}>{cicle}</Text6>
                        </div>
                    </div>
                    <div className='extraBonusDetails-page__content'>
                        <div className='extraBonusDetails-page__content-subtitle'>
                            <Text3 regular>{t('bonusExtraDescription')}</Text3>
                        </div>
                        {mobile && (
                            <div>
                                <div className='extraBonusDetails-page__content-line'>
                                    <Text1 medium color={skinVars.colors.textSecondary}>
                                        {t('mobileLineMay')} - {mobile.number && formatMobileNumber(mobile.number)}
                                    </Text1>
                                </div>
                                <RowList>
                                    {!mobile.bonusInfos || mobile.bonusInfos.length === 0 ? (
                                        <Row
                                            title={''}
                                            headline={''}
                                            extra={<Text2 regular>{t('bonusExtraNoBonus')}</Text2>}
                                        />
                                    ) : (
                                        mobile.bonusInfos.map((bonus: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    <Row
                                                        title={''}
                                                        headline={''}
                                                        extra={<Text2 regular>{bonus.name}</Text2>}
                                                        right={<Text6>{formatPrices(bonus.price, 'rate')}</Text6>}
                                                    />
                                                </div>
                                            );
                                        })
                                    )}
                                </RowList>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
                </div>
            )}
        </>
    );
};

export default ExtraBonusDetails;
